import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-analytics',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './analytics.html',
  styleUrl: './analytics.css'
})
export class AnalyticsComponent {
  features = [
    {
      icon: 'bi-graph-up-arrow',
      title: 'Google Analytics 4',
      description: 'Comprehensive GA4 implementation with advanced tracking, custom events, and cross-platform measurement for complete user journey insights.'
    },
    {
      icon: 'bi-layers',
      title: 'Google Tag Manager',
      description: 'Streamlined tag management system for efficient deployment of tracking codes, conversion pixels, and marketing tags without code changes.'
    },
    {
      icon: 'bi-bar-chart-line',
      title: 'Custom Dashboards',
      description: 'Build tailored analytics dashboards that visualize your most important metrics and KPIs in real-time for actionable insights.'
    },
    {
      icon: 'bi-pie-chart',
      title: 'Data Visualization',
      description: 'Transform complex data into clear, actionable visualizations that help stakeholders understand performance at a glance.'
    },
    {
      icon: 'bi-diagram-3',
      title: 'Attribution Modeling',
      description: 'Multi-touch attribution analysis to understand which channels and touchpoints drive conversions throughout the customer journey.'
    },
    {
      icon: 'bi-shield-check',
      title: 'Privacy Compliance',
      description: 'GDPR and CCPA-compliant tracking implementations that respect user privacy while capturing essential business intelligence.'
    }
  ];

  process = [
    {
      step: '01',
      title: 'Audit & Strategy',
      description: 'Review current analytics setup, identify gaps, and develop comprehensive tracking strategy aligned with business objectives.'
    },
    {
      step: '02',
      title: 'Implementation',
      description: 'Deploy tracking codes, configure events, set up conversion tracking, and implement tag management systems across all platforms.'
    },
    {
      step: '03',
      title: 'Dashboard Creation',
      description: 'Build custom dashboards and reports that present data in meaningful ways, making insights accessible to all stakeholders.'
    },
    {
      step: '04',
      title: 'Optimization & Insights',
      description: 'Continuous monitoring, analysis, and refinement of tracking setup to ensure accurate data and actionable business insights.'
    }
  ];

  caseStudy = {
    client: 'DataDrive Solutions',
    industry: 'B2B SaaS',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop',
    challenge: 'DataDrive Solutions struggled with fragmented analytics across multiple platforms, making it impossible to understand the complete customer journey and accurately attribute revenue to marketing efforts.',
    solution: 'We implemented a unified analytics ecosystem with GA4, custom GTM tracking for all user interactions, multi-touch attribution modeling, and executive dashboards that provided real-time visibility into performance metrics.',
    results: [
      '100% visibility into customer journey across all touchpoints',
      '85% improvement in data accuracy and reliability',
      '60% reduction in time spent on manual reporting',
      '$2.4M in additional revenue identified through attribution insights'
    ]
  };

  testimonial = {
    quote: 'HoneyKode transformed our analytics from a black box into a powerful decision-making tool. We now understand exactly which marketing efforts drive revenue and can optimize with confidence. The custom dashboards they built save our team hours every week.',
    author: 'Jennifer Park',
    role: 'VP of Marketing',
    company: 'DataDrive Solutions',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&h=200&fit=crop'
  };
}
